import * as React from 'react';
import { IconChevronRight16, IconTrash16, UIText1, useDeviceType, Responsive } from '@cian/ui-kit';
import classNames from 'classnames';
import { formatPhoneWithSpecialChars } from '../../utils/formatString';
import { ERememberedAccountType } from '../../types/rememberedAccounts';
import { mapTypeToIcon } from './mapTypeToIcon';
import * as styles from './styles.css';
import { DeletItemSwipeButton } from '../DeletItemSwipeButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var RememberedAccountItem = function RememberedAccountItem(_ref) {
  var type = _ref.type,
    value = _ref.value,
    index = _ref.index,
    onClick = _ref.onClick,
    onDelete = _ref.onDelete;
  var deviceType = useDeviceType();
  var handleClick = React.useCallback(function () {
    onClick(type, value, index);
  }, [type, value, index, onClick]);
  var handleDelete = React.useCallback(function (e) {
    e.stopPropagation();
    onDelete(type, value, index);
  }, [type, value, index, onDelete]);
  var formattedValue = React.useMemo(function () {
    if (type === ERememberedAccountType.Phone) {
      return formatPhoneWithSpecialChars(value);
    } else {
      return value;
    }
  }, [value, type]);
  return /*#__PURE__*/_jsxs("div", {
    onClick: handleClick,
    className: classNames(styles['container'], styles["container--".concat(deviceType)]),
    "data-testid": "RememberedAccountItem",
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles['content'],
      children: [/*#__PURE__*/_jsx("div", {
        className: styles['icon'],
        children: mapTypeToIcon(type)
      }), /*#__PURE__*/_jsx("div", {
        className: styles['text-value'],
        children: /*#__PURE__*/_jsx(UIText1, {
          children: formattedValue
        })
      }), /*#__PURE__*/_jsx("button", {
        "data-name": "ChevronBtn",
        className: classNames(styles['chevron-button'], styles["chevron-button--".concat(deviceType)]),
        children: /*#__PURE__*/_jsx(IconChevronRight16, {
          color: "primary_100"
        })
      }), /*#__PURE__*/_jsx(Responsive, {
        desktop: true,
        children: /*#__PURE__*/_jsx("button", {
          "data-name": "CloseBtn",
          className: classNames(styles['delete-button'], styles["delete-button--".concat(deviceType)]),
          onClick: handleDelete,
          children: /*#__PURE__*/_jsx(IconTrash16, {
            color: "primary_100"
          })
        })
      })]
    }), /*#__PURE__*/_jsx(Responsive, {
      phone: true,
      tablet: true,
      children: /*#__PURE__*/_jsx(DeletItemSwipeButton, {
        onClick: handleDelete
      })
    })]
  });
};